import { rotatePoint } from "@pdfme/schemas"
import { motion } from "framer-motion"
import GlitchEffect from "../../../components/ui/animations/glitch-text-animation"

export default function PluginFailedCover() {
	const pathVariants = {
		hidden: {
			opacity: 0,
			pathLength: 0,
		},
		visible: {
			opacity: 1,
			pathLength: 1,
			transition: {
				duration: 2,
				ease: "easeInOut",
			},
		},
	}
	return (
		<svg
			width="382"
			height="178"
			viewBox="0 0 382 178"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clip-path="url(#clip0_25677_9721)">
				<path
					d="M140 89C140 60.8335 162.833 38 191 38C219.167 38 242 60.8335 242 89C242 117.167 219.167 140 191 140C162.833 140 140 117.167 140 89Z"
					fill="#F96767"
				/>
				<path
					d="M205.052 81.1611C204.959 81.7693 205.163 82.3851 205.597 82.8195L208.559 85.7813C209.447 86.6691 209.893 87.8345 209.893 89C209.893 90.1654 209.449 91.329 208.559 92.2186L205.516 95.2616C205.312 95.4659 205.062 95.6195 204.788 95.7101C204.513 95.8006 204.221 95.8256 203.935 95.783C203.047 95.6507 202.42 94.8763 202.107 94.0357C201.832 93.293 201.374 92.6314 200.776 92.1117C200.179 91.592 199.46 91.2309 198.686 91.0617C197.912 90.8924 197.109 90.9204 196.348 91.1432C195.588 91.3659 194.896 91.7761 194.336 92.3362C193.776 92.8963 193.366 93.5882 193.143 94.3483C192.921 95.1084 192.893 95.9123 193.062 96.6861C193.231 97.4598 193.592 98.1786 194.112 98.7763C194.631 99.3741 195.293 99.8315 196.036 100.107C196.878 100.42 197.651 101.045 197.783 101.935C197.826 102.221 197.801 102.513 197.71 102.788C197.62 103.062 197.466 103.312 197.262 103.516L194.221 106.557C193.798 106.981 193.296 107.317 192.744 107.546C192.191 107.775 191.598 107.893 191 107.893C190.402 107.893 189.81 107.776 189.258 107.547C188.705 107.318 188.204 106.982 187.781 106.559L184.82 103.597C184.606 103.383 184.344 103.222 184.057 103.126C183.769 103.031 183.463 103.005 183.163 103.05C182.232 103.189 181.576 104.002 181.236 104.878C180.951 105.609 180.489 106.258 179.89 106.766C179.291 107.274 178.575 107.624 177.807 107.785C177.038 107.946 176.242 107.914 175.49 107.69C174.737 107.466 174.052 107.058 173.497 106.503C172.942 105.948 172.534 105.263 172.31 104.511C172.086 103.758 172.054 102.962 172.215 102.193C172.376 101.425 172.726 100.709 173.234 100.11C173.742 99.5115 174.391 99.0486 175.122 98.7636C175.999 98.4236 176.811 97.7682 176.949 96.837C176.993 96.5374 176.967 96.2315 176.873 95.9438C176.778 95.6561 176.617 95.3947 176.403 95.1804L173.441 92.2186C173.018 91.7965 172.682 91.2948 172.453 90.7424C172.224 90.19 172.107 89.5979 172.107 89C172.107 87.8345 172.553 86.6691 173.441 85.7813L176.323 82.8989C176.777 82.4455 177.421 82.2321 178.056 82.3265C179.028 82.472 179.712 83.3239 180.082 84.2343C180.376 84.9554 180.844 85.5925 181.444 86.089C182.044 86.5855 182.758 86.9259 183.521 87.0799C184.284 87.2339 185.074 87.1967 185.819 86.9717C186.565 86.7466 187.243 86.3407 187.794 85.7901C188.345 85.2394 188.751 84.5611 188.976 83.8156C189.201 83.0701 189.238 82.2805 189.084 81.5171C188.93 80.7537 188.589 80.0403 188.093 79.4403C187.596 78.8404 186.959 78.3725 186.238 78.0784C185.328 77.7082 184.476 77.0244 184.33 76.0516C184.236 75.417 184.448 74.7747 184.903 74.3195L187.783 71.439C188.205 71.0161 188.707 70.6808 189.259 70.4523C189.811 70.2238 190.403 70.1065 191 70.1073C192.166 70.1073 193.331 70.5531 194.219 71.4409L197.181 74.4026C197.615 74.8371 198.231 75.0411 198.837 74.9504C199.768 74.8106 200.424 73.9984 200.764 73.122C201.049 72.3905 201.512 71.7416 202.11 71.234C202.709 70.7264 203.425 70.3761 204.194 70.2148C204.962 70.0535 205.758 70.0862 206.511 70.3101C207.263 70.534 207.948 70.942 208.503 71.4971C209.058 72.0522 209.466 72.737 209.69 73.4894C209.914 74.2418 209.947 75.0382 209.785 75.8065C209.624 76.5748 209.274 77.2908 208.766 77.8896C208.258 78.4885 207.61 78.9513 206.878 79.2363C206.002 79.5763 205.189 80.2299 205.052 81.1611Z"
					stroke="white"
					stroke-width="3.77778"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M191 278.5C86.342 278.5 1.5 193.658 1.5 89C1.5 -15.658 86.342 -100.5 191 -100.5C295.658 -100.5 380.5 -15.658 380.5 89C380.5 193.658 295.658 278.5 191 278.5Z"
					stroke="#F96767"
					stroke-opacity="0.2"
					stroke-width="3"
				/>
				<path
					d="M191 228.5C113.956 228.5 51.5 166.044 51.5 89C51.5 11.9563 113.956 -50.5 191 -50.5C268.044 -50.5 330.5 11.9563 330.5 89C330.5 166.044 268.044 228.5 191 228.5Z"
					stroke="#F96767"
					stroke-opacity="0.4"
					stroke-width="3"
				/>
				<path
					d="M191 173.5C144.332 173.5 106.5 135.668 106.5 89C106.5 42.3319 144.332 4.5 191 4.5C237.668 4.5 275.5 42.3319 275.5 89C275.5 135.668 237.668 173.5 191 173.5Z"
					stroke="#F96767"
					stroke-opacity="0.7"
					stroke-width="3"
				/>
				<path
					d="M252 166C233.775 166 219 151.225 219 133C219 114.775 233.775 100 252 100C270.225 100 285 114.775 285 133C285 151.225 270.225 166 252 166Z"
					fill="white"
				/>
				<path
					d="M252 166C233.775 166 219 151.225 219 133C219 114.775 233.775 100 252 100C270.225 100 285 114.775 285 133C285 151.225 270.225 166 252 166Z"
					stroke="#DC2626"
					stroke-width="2"
				/>
				<path
					d="M259.554 125.444L244.443 140.556M244.443 125.444L259.554 140.556"
					stroke="#DC2626"
					stroke-width="2.51852"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_25677_9721">
					<rect width="382" height="178" fill="white" />
				</clipPath>
			</defs>
		</svg>
	)
}

export function PluginSuccessCover() {
	return (
		<svg
			width="382"
			height="178"
			viewBox="0 0 382 178"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clip-path="url(#clip0_25679_10668)">
				<path
					d="M140 89C140 60.8335 162.833 38 191 38V38C219.167 38 242 60.8335 242 89V89C242 117.167 219.167 140 191 140V140C162.833 140 140 117.167 140 89V89Z"
					fill="#059670"
				/>
				<path
					d="M205.052 81.1611C204.959 81.7693 205.163 82.3851 205.597 82.8195L208.559 85.7813C209.447 86.6691 209.893 87.8345 209.893 89C209.893 90.1654 209.449 91.329 208.559 92.2186L205.516 95.2616C205.312 95.4659 205.062 95.6195 204.788 95.7101C204.513 95.8006 204.221 95.8256 203.935 95.783C203.047 95.6507 202.42 94.8763 202.107 94.0357C201.832 93.293 201.374 92.6314 200.776 92.1117C200.179 91.592 199.46 91.2309 198.686 91.0617C197.912 90.8924 197.109 90.9204 196.348 91.1432C195.588 91.3659 194.896 91.7761 194.336 92.3362C193.776 92.8963 193.366 93.5882 193.143 94.3483C192.921 95.1084 192.893 95.9123 193.062 96.6861C193.231 97.4598 193.592 98.1786 194.112 98.7763C194.631 99.3741 195.293 99.8315 196.036 100.107C196.878 100.42 197.651 101.045 197.783 101.935C197.826 102.221 197.801 102.513 197.71 102.788C197.62 103.062 197.466 103.312 197.262 103.516L194.221 106.557C193.798 106.981 193.296 107.317 192.744 107.546C192.191 107.775 191.598 107.893 191 107.893C190.402 107.893 189.81 107.776 189.258 107.547C188.705 107.318 188.204 106.982 187.781 106.559L184.82 103.597C184.606 103.383 184.344 103.222 184.057 103.126C183.769 103.031 183.463 103.005 183.163 103.05C182.232 103.189 181.576 104.002 181.236 104.878C180.951 105.609 180.489 106.258 179.89 106.766C179.291 107.274 178.575 107.624 177.807 107.785C177.038 107.946 176.242 107.914 175.49 107.69C174.737 107.466 174.052 107.058 173.497 106.503C172.942 105.948 172.534 105.263 172.31 104.511C172.086 103.758 172.054 102.962 172.215 102.193C172.376 101.425 172.726 100.709 173.234 100.11C173.742 99.5115 174.391 99.0486 175.122 98.7636C175.999 98.4236 176.811 97.7682 176.949 96.837C176.993 96.5374 176.967 96.2315 176.873 95.9438C176.778 95.6561 176.617 95.3947 176.403 95.1804L173.441 92.2186C173.018 91.7965 172.682 91.2948 172.453 90.7424C172.224 90.19 172.107 89.5979 172.107 89C172.107 87.8345 172.553 86.6691 173.441 85.7813L176.323 82.8989C176.777 82.4455 177.421 82.2321 178.056 82.3265C179.028 82.472 179.712 83.3239 180.082 84.2343C180.376 84.9554 180.844 85.5925 181.444 86.089C182.044 86.5855 182.758 86.9259 183.521 87.0799C184.284 87.2339 185.074 87.1967 185.819 86.9717C186.565 86.7466 187.243 86.3407 187.794 85.7901C188.345 85.2394 188.751 84.5611 188.976 83.8156C189.201 83.0701 189.238 82.2805 189.084 81.5171C188.93 80.7537 188.589 80.0403 188.093 79.4403C187.596 78.8404 186.959 78.3725 186.238 78.0784C185.328 77.7082 184.476 77.0244 184.33 76.0516C184.236 75.417 184.448 74.7747 184.903 74.3195L187.783 71.439C188.205 71.0161 188.707 70.6808 189.259 70.4523C189.811 70.2238 190.403 70.1065 191 70.1073C192.166 70.1073 193.331 70.5531 194.219 71.4409L197.181 74.4026C197.615 74.8371 198.231 75.0411 198.837 74.9504C199.768 74.8106 200.424 73.9984 200.764 73.122C201.049 72.3905 201.512 71.7416 202.11 71.234C202.709 70.7264 203.425 70.3761 204.194 70.2148C204.962 70.0535 205.758 70.0862 206.511 70.3101C207.263 70.534 207.948 70.942 208.503 71.4971C209.058 72.0522 209.466 72.737 209.69 73.4894C209.914 74.2418 209.947 75.0382 209.785 75.8065C209.624 76.5748 209.274 77.2908 208.766 77.8896C208.258 78.4885 207.61 78.9513 206.878 79.2363C206.002 79.5763 205.189 80.2299 205.052 81.1611Z"
					stroke="white"
					stroke-width="3.77778"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path
					d="M191 278.5C86.342 278.5 1.5 193.658 1.5 89C1.5 -15.658 86.342 -100.5 191 -100.5C295.658 -100.5 380.5 -15.658 380.5 89C380.5 193.658 295.658 278.5 191 278.5Z"
					stroke="#059670"
					stroke-opacity="0.2"
					stroke-width="3"
				/>
				<path
					d="M191 228.5C113.956 228.5 51.5 166.044 51.5 89C51.5 11.9563 113.956 -50.5 191 -50.5C268.044 -50.5 330.5 11.9563 330.5 89C330.5 166.044 268.044 228.5 191 228.5Z"
					stroke="#059670"
					stroke-opacity="0.4"
					stroke-width="3"
				/>
				<path
					d="M191 173.5C144.332 173.5 106.5 135.668 106.5 89C106.5 42.3319 144.332 4.5 191 4.5C237.668 4.5 275.5 42.3319 275.5 89C275.5 135.668 237.668 173.5 191 173.5Z"
					stroke="#059670"
					stroke-opacity="0.7"
					stroke-width="3"
				/>
				<path
					d="M252 166C233.775 166 219 151.225 219 133C219 114.775 233.775 100 252 100C270.225 100 285 114.775 285 133C285 151.225 270.225 166 252 166Z"
					fill="white"
				/>
				<path
					d="M252 166C233.775 166 219 151.225 219 133C219 114.775 233.775 100 252 100C270.225 100 285 114.775 285 133C285 151.225 270.225 166 252 166Z"
					stroke="#10B98C"
					stroke-width="2"
				/>
				<path
					d="M262.074 125.444L248.222 139.296L241.926 133"
					stroke="#047859"
					stroke-width="2.51852"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_25679_10668">
					<rect width="382" height="178" fill="white" />
				</clipPath>
			</defs>
		</svg>
	)
}
